import { useEffect, useState } from 'react';

// date_of_change: 2026-07-25
// A phone in landscape needs a map-first layout even when its pixel width is
// greater than a tablet breakpoint. Keep this query shared so the rails,
// session bar, and stage tools enter the same compact mode together.
export const BATTLE_ROOM_COMPACT_VIEWPORT_QUERY =
  '(max-width: 1024px), (max-height: 700px) and (orientation: landscape)';

const readCompactViewport = () => (
  typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && window.matchMedia(BATTLE_ROOM_COMPACT_VIEWPORT_QUERY).matches
);

const useBattleRoomCompactViewport = () => {
  const [isCompactViewport, setIsCompactViewport] = useState(readCompactViewport);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = window.matchMedia(BATTLE_ROOM_COMPACT_VIEWPORT_QUERY);
    const syncViewportMode = () => setIsCompactViewport(mediaQuery.matches);

    syncViewportMode();
    mediaQuery.addEventListener?.('change', syncViewportMode);
    return () => mediaQuery.removeEventListener?.('change', syncViewportMode);
  }, []);

  return isCompactViewport;
};

export default useBattleRoomCompactViewport;
